webpackJsonp([273950069227526],{

/***/ 480:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Windswell Studio is home to the production of Will Simons, a sculptor and craftsperson working in clay, wood and metals since 2004. Will was raised in the Northeast and lived in Southern California from 2005 to 2017. He received a BFA in Sculpture in 2009 and an MFA in Ceramics in 2019. His work is informed by a diverse range of experience in architecture, exhibition design, kiln fabrication, cabinetry, welding, casting and studio ceramics.</p>","frontmatter":{"title":"Bio"}}},"pathContext":{"id":"/opt/build/repo/src/pages/about/index.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-d4f1b0d50befa473423e.js